import { Controller } from "@hotwired/stimulus";

// reCAPTCHA takes its theme once, when its script renders the widget, so the theme is set before the script loads.
export default class extends Controller {
  static values = { script: String };

  connect() {
    if (!this.hasScriptValue) return;

    // The stylesheet declares dark only where its dark theme is on, so this follows that switch as well as the OS.
    const dark = getComputedStyle(document.documentElement).colorScheme === "dark";
    this.element.querySelector(".g-recaptcha").dataset.theme = dark ? "dark" : "light";

    const script = document.createElement("script");
    script.src = this.scriptValue;
    script.async = true;
    document.head.append(script);
  }
}
